import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {countActions, selectPendingPlacePosition} from "./countSlice";
import {viewActions} from "../view/viewSlice";
import {PlaceMultiplesModal} from "./PlaceMultiplesModal";

export function PlaceMultiplesModalContainer() {
	const dispatch = useDispatch();
	const pendingPosition = useSelector(selectPendingPlacePosition);

	function handleConfirm(quantity: number) {
		if (pendingPosition) {
			dispatch(countActions.addCountItem({
				position: pendingPosition,
				quantity
			}));
			dispatch(viewActions.clearHighlight({}));
			dispatch(countActions.clearPendingPlacePosition());
		}
	}

	function handleClose() {
		dispatch(countActions.clearPendingPlacePosition());
	}

	return (
		<PlaceMultiplesModal
			isOpen={!!pendingPosition}
			onClose={handleClose}
			onConfirm={handleConfirm}
		/>
	);
}
